module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Some say"), _c('span', {
    staticClass: "Bold-Style",
    attrs: {
      "lang": "en-US"
    }
  }), _vm._v("the carnival is gone now, drowned out by decency and digital magic. But don’t you believe it. Carnival doesn’t die. It morphs and fractures and flares again. It flickers and sometimes rots, but it is rooted in ancient nightmares and it feeds on their immortality. It masquerades as giddy fun but the carnival is about fear, which is eternal. True, in some regions the old freak shows have receded into myth, and the simp twisters have safety harnesses. But the shrill music still cloaks a high and endless scream. The dark is still there behind the swirling lights. And that dark is what we need.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The midway teeters over an abyss, and the abyss draws us. The high wire and trapeze freeze our breath, and the rides taunt our blood-deep fear of falling. The fire-eaters snatch us back to a time when we had to flee the burning. The beasts remind us that we are smallish, ill-equipped predators, but eminently edible prey.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And we are prey to each other. The booths and spieling barkers lure us to booby-trapped tests of skill or luck or destiny. Their sleazy glitter is far more seductive than the humdrum camouflage of the dangerous day-to-day.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We defend ourselves feebly, declaring it’s all smoke and mirrors, tricks and cons that don’t fool us. We’re onto them. But we end up falling for lies, and doubting the astounding truth. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If our innermost terrors are incarnate in the midway, there is also hope. The acrobats, the fliers, the sword swallowers and torch jugglers defy gravity and anatomy. The freaks trigger our horror of the alien within, but they, and their nimble cohort, are beyond us. They possess an uncanny superlative, an eerie defiance of normality, physics, and frailty. They flout perils that overwhelm us.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We watch, amazed, and grapple with our fears. The carnival lets us do that in what passes for safety. And when the calliope moves on, what remains are torn tickets, spilled popcorn, and strange stories shifting on the night wind. The stories stay with us, and they grow.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Crows probably croak whole sagas of snakes and hawks, cats and shotguns. Mice sing each other to sleep with images of traps and talons, sly escapes and tragic endings. Long ago, in some cliff notch above a shifting sea, our grandmother—great to the umpteenth power—hunched to tell the little ones what to fear. These scary fables are the original carnival of the mind.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Every generation spins its own tales, fresh smoke signals from our smoldering fears. Like the cackling Ghost Tunnels, the Cyclone rides, and the snake charmers, the stories raise our hackles and acquaint us with the physical sensations of dread, creeping horror, and the shock of terror. This experience is essential for our survival. We absorb the stories and learn how fear feels, so when those sweeping emotions come at us out of life we are not paralyzed by them, but can react. If the stranger’s smile takes on a peculiar twist, we step back and walk away. When the siren shrieks in the dark, we rise and run.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So welcome this collection of extremely useful stories from the Nightmare Carnival. Strap yourself in and buckle up. You’re in for a wild ride.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—Katherine Dunn")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("March 2014")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5066b985","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nightmarecarnivalepub20.vue
// module id = 75
// module chunks = 0